<template>
  <div v-show="notepadVisible" :class="$style.container">
    <h1>Meeting Notes</h1>

    <back-to-call
      @click="hideNotepad"
      :name="contactName || contactNumber"
      :photoUrl="contactPhotoUrl" />

    <activity-notes
      v-if="hasActivityNotesActivity"
      :focus="notepadVisible"
      :class="$style.activityNotes" />

    <end-call-button :class="$style.endCallButton" />
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import BackToCall from '../shared/back-to-call/back-to-call'
  import ActivityNotes from 'vue-components/activity-notes/components/activity-notes'
  import EndCallButton from '../end-call-button/end-call-button'

  const { mapState, mapGetters, mapActions } = createNamespacedHelpers('conference')
  const {
    mapGetters: mapActivityNotesGetters,
    mapMutations: mapActivityNotesMutations
  } = createNamespacedHelpers('activityNotes')

  export default {
    components: {
      BackToCall,
      ActivityNotes,
      EndCallButton
    },
    computed: {
      ...mapState([
        'activity',
        'notepadVisible'
      ]),
      ...mapGetters([
        'contactName',
        'contactNumber',
        'contactPhotoUrl'
      ]),
      ...mapActivityNotesGetters({
        hasActivityNotesActivity: 'hasActivity'
      })
    },
    beforeDestroy () {
      this.resetActivityNotes()
    },
    methods: {
      ...mapActions([
        'hideNotepad'
      ]),
      ...mapActivityNotesMutations({
        setActivityNotesActivity: 'setActivity',
        resetActivityNotes: 'reset'
      })
    },
    watch: {
      activity (value) {
        this.setActivityNotesActivity(value)
      }
    }
  }
</script>

<style module lang="less" src="./notepad.less"></style>



// WEBPACK FOOTER //
// notepad.vue?9eeabb00